import { ActionIcon, Modal, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconShare3 } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import LeadsSharingContent from "./LeadsSharingContent";

const LeadsSharing = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Tooltip label={lang.leads.share_tooltip}>
        <ActionIcon
          variant="light"
          size={36}
          radius={"md"}
          mx={12}
          onClick={open}
          disabled={disabled}
        >
          <IconShare3 size={20} />
        </ActionIcon>
      </Tooltip>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.prm.sharing.my_sharings}
        size={"40%"}
      >
        <LeadsSharingContent handleClose={close} />
      </Modal>
    </>
  );
};

export default LeadsSharing;
